// Mock data for Kango9 School - Baduk Lessons clone
export const navLinks = [
  { name: 'Home', href: '#home' },
  { name: 'Lessons', href: '#lessons' },
  { name: 'Teacher', href: '#teacher' },
  { name: 'About', href: '#about' },
  { name: 'Book', href: '#book' },
  { name: 'Reviews', href: '#reviews' },
  { name: 'Blog', href: '#blog' },
  { name: 'FAQ', href: '#FAQ' },
  { name: 'Contact', href: '#contact' },
];

export const heroFeatures = [
  {
    icon: 'UserRound',
    title: 'Personalized Lessons',
    text: 'Lessons tailored to your level and goals.',
  },
  {
    icon: 'TrendingUp',
    title: 'Real Improvement',
    text: 'Proven methods to help you level up faster.',
  },
  {
    icon: 'CalendarDays',
    title: 'Flexible Scheduling',
    text: 'Book lessons at times that fit your life.',
  },
  {
    icon: 'Globe',
    title: 'Students Worldwide',
    text: 'Trusted by students from 12+ countries.',
  },
];

export const lessons = [
  {
    id: 1,
    name: 'Standard Lesson',
    duration: '1 Hour',
    price: '30',
    description: 'A focused one-on-one session covering openings, joseki, or any topic you choose. Perfect for steady weekly progress.',
    features: [
      'One-on-one private session',
      'Choose your focus area',
      'Personalized feedback',
      'Homework problems included',
    ],
    popular: false,
  },
  {
    id: 2,
    name: 'Ambitious Lesson',
    duration: '2 Hours',
    price: '45',
    description: 'A deep dive session designed for serious players who want accelerated improvement and detailed analysis.',
    features: [
      'Extended 2-hour session',
      'Deep strategic analysis',
      'Custom training plan',
      'Priority scheduling',
      'Follow-up notes',
    ],
    popular: true,
  },
  {
    id: 3,
    name: 'Game Review',
    duration: '1 Hour',
    price: '25',
    description: 'Send me your game from OGS, KGS, Fox, or Tygem and I will provide a detailed move-by-move review.',
    features: [
      'OGS / KGS / Fox / Tygem',
      'Move-by-move breakdown',
      'Mistakes & alternatives',
      'Written summary provided',
    ],
    popular: false,
  },
];

// NOTE: Discount codes are managed on the backend.
// They live in the MongoDB `discount_codes` collection (seeded on server
// startup from SEED_DISCOUNT_CODES in server.py) so they can be enforced
// as strictly single-use across all users. The frontend validates them
// via POST /api/discount/validate.

export const teacherStats = [
  { label: 'Years Playing', value: '12+' },
  { label: 'WBaduk Rank', value: '8 Dan' },
  { label: 'Fox Rank', value: '8 Dan' },
  { label: 'Tygem Rank', value: '7 Dan' },
];

export const teacherInfo = {
  name: 'George Gigoi',
  handle: 'Kango9',
  bio: 'Hello and welcome! My name is George Gigoi and I have been playing Go for over 12 years. I have extensive experience teaching both children and adults online, helping students from 20 kyu all the way up to 3 dan reach their personal goals. My approach blends strategic depth with patient, clear explanations so you can actually feel your strength grow with every game.',
};

export const benefits = [
  { number: '01', title: 'Strategic Thinking', text: 'Develop long-term planning and learn how to evaluate complex positions multiple moves ahead.' },
  { number: '02', title: 'Problem Solving', text: 'Sharpen your ability to break down problems and find creative solutions under pressure.' },
  { number: '03', title: 'Patience & Discipline', text: 'Train the calm focus required to play strong moves instead of reactive ones.' },
  { number: '04', title: 'Deep Concentration', text: 'Build the kind of attention span that benefits every area of your life and work.' },
  { number: '05', title: 'Adaptability', text: 'Learn to adjust your plan when your opponent surprises you, a vital real-world skill.' },
  { number: '06', title: 'Emotional Resilience', text: 'Master your emotions during difficult games and turn losses into your biggest lessons.' },
];

export const reviews = [
  {
    id: 1,
    name: 'Tenuki',
    rank: '13 Kyu, Pandanet',
    country: 'France',
    text: 'George has been an invaluable teacher throughout my Go journey. He clearly explained the most important concepts I needed to grasp early on and showed me exactly which good habits to focus on for the most effective learning. Rather than overwhelming me with too much information, he helped me prioritize what truly matters at each stage. George accompanied me closely every step of the way, keeping me firmly on the right track for consistent improvement. Thanks to its structured and thoughtful approach, I now feel much more confident in my direction and progress in the game.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Jay P.',
    rank: '15 Kyu, Fox',
    country: 'France',
    text: 'So at the ripe age of 65 I finally decided to follow through on learning the game of Go. On my own online, videos, club and more I was not getting any traction. This all changed when I found the sensei I needed. With a variety of training tools George has cleared away the fog of the game by highlighting the fundamental principles. This combined with his monumental patience makes him quite the formidable baduk professor. ',
    rating: 5,
  },
  {
    id: 3,
    name: 'Holonomy',
    rank: '11 kyu, OGS',
    country: 'United States',
    text: 'Kango is a superb Go teacher. First of all he is a strong player who has studied Go and understands what students need to learn to improve. Kango gives careful thought to the particular student he is working with, so that the comments and criticism are appropiate for the student’s level. I also appreciate that Kango is calm and always positive about my play, even though I may be neither.',
    rating: 5,
  },
  {
    id: 4,
    name: 'Fbpop',
    rank: '11 Kyu, OGS',
    country: 'Switzerland',
    text: 'I have been taking lessons with Kango9 for 9+ months, and the experience has completely transformed my approach to Go. As a high 20s kyu I was really struggling with the fundamentals, how to develop intuition, judging what and how to read... pretty much everything, I just had a strong desire to learn. At the moment of writing this, I am at 11 kyu on OGS, with clarity on my weaknesses and strengths, and haven’t faced any other significant plateaus yet. Kango9 has an incredible ability to translate complex concepts into clear, actionable principles. He actually explains the why behind the moves. I also greatly appreciate his restraint during game reviews; rather than overwhelming me by pointing out every single sub-optimal move, Kango9 identifies the root cause of my mistakes and helps me focus on fixing essential unhealthy habits, perspectives, or attitudes.  Highly recommended for anyone looking to genuinely improve their understanding of themselves and the game!',
    rating: 5,
  },
  {
    id: 5,
    name: 'Anonymous',
    rank: '2 Dan, Fox',
    country: '-',
    text: 'Kango is undoubtedly one of the best teachers I’ve ever had. Before him, I worked with many teachers, most of whom taught Go by simply showcasing their own good moves. While learning through these moves can be somewhat helpful, it’s often time-consuming and stressful. Kango approaches teaching differently. He takes the time to explain concepts clearly, using logic and analogies that make learning easier and more efficient. Though he may not be a professional dan player yet, he certainly knows how to guide you through the learning process without wasting time. I’m now the most efficient player in my friend group, and many of them have pro-level teachers. His first lesson was free for me, so I figured, why not give it a try? I’m so glad I did it was an incredible experience.',
    rating: 5,
  },
];

export const faqs = [
  {
    q: 'I am a complete beginner. Can I still take lessons?',
    a: 'Absolutely. Lessons are designed for players from 20 kyu through 3 dan. We can start from the very basics of rules and capture techniques if needed.',
  },
  {
    q: 'What platform do we use for lessons?',
    a: 'Lessons are conducted online over audio call paired with an interactive Go board on OGS or KGS. You only need a stable internet connection.',
  },
  {
    q: 'How do I pay?',
    a: 'Payments are accepted via PayPal or bank transfer.',
  },
  {
    q: 'How often should I take lessons?',
    a: 'Most students see best results with one lesson per week combined with regular practice games and tsumego homework.',
  },
  {
    q: 'Do you teach children?',
    a: 'Yes! I have years of experience teaching kids. Lessons are kept fun, interactive, and age-appropriate.',
  },
  {
    q: 'Can I get a refund/reschedule?',
    a: 'Yes! If you send me a message at least 12 hours before our lesson, we can reschedule it or you can request a refund. Messages sent less than 12 hours before the lesson will be considered a full payment for the lesson.',
  },
];

export const blognumber = 3;

export const blogPosts = [
  {
    
    id: 1,
    slug: 'The Psychology of the Game: How Mindset Shapes Victory',
    title: 'The Psychology of the Game: How Mindset Shapes Victory',
    excerpt:
      'How Understanding Psychology Can Improve Your Game?',
    date: 'Apr 2, 2025',
    readTime: '7 min read',
    category: 'Psychology',
    author: 'Kango9',
    image:
      'https://images.pexels.com/photos/37403743/pexels-photo-37403743.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    content: [
      {
        type: 'p',
        text: 'Hello everyone,',
      },
      {
        type: 'p',
        text: 'For those who don’t know me, I’m Kango. A while ago, I started teaching Go online, and one thing quickly became clear to me: many players think improvement comes only from studying joseki, tsumego, or playing more games.',
      },
      {
        type: 'p',
        text: 'But Go is not just a game of moves. It is also a game of psychology. The way you think, react, handle pressure, and approach mistakes has a huge impact on your results.Two players can have similar technical knowledge, yet one consistently performs better because of mindset alone.',
      },
      {
        type: 'p',
        text: 'A few years ago, I collaborated with a content creator (Jaystrategy) on a video discussing this topic. We talked about shapes, decision-making, and the mental side of Go. What surprised me was how many people resonated with the psychological aspect of the game rather than the technical one. That experience inspired me to write more about it.',
      },
      { type: 'h2', text: 'The Hidden Side of Go' },
      {
        type: 'p',
        text: 'Most players focus entirely on finding the “correct” move. While that matters, improvement also depends on emotional control, confidence, discipline, and awareness.',
      },
      {
        type: 'p',
        text: 'Fear, for example, changes the way people play. When players become afraid of losing, they often become passive. They add unnecessary defensive moves, avoid complicated fights, and slowly give away the control of the game. Your opponent will immediately take advantage of that hesitation.',
      },
      {
        type: 'p',
        text: 'On the other hand, players who are calm and confident tend to make clearer decisions. They are more willing to take responsibility for their moves, accept mistakes, and continue playing actively even under pressure. This doesn’t mean reckless aggression is good. It means fear should not control your decisions.',
      },
      { type: 'h2', text: ' Why Stronger Players Sometimes Lose' },
      {
        type: 'p',
        text: 'One of the most interesting things about Go is that stronger players do not always win. Technical skill matters, of course, but performance is influenced by many psychological factors:',
      },
      { type: 'list', items: [
        {
          title:'Emotional Control',
          text:
          'Some players collapse after making a mistake. Others stay composed and continue playing well. The ability to recover mentally during a game is an underrated skill.',
        },
        {
          title:'Discipline',
          text:
          'Improvement requires consistency. Many players study intensely for a short period, burn out, and quit. Others study a little every day for years and steadily become stronger.',
        },
        {
          title:'Energy and Focus',
          text:
          'Go demands concentration. A tired or distracted player will miss things they would normally see instantly. Learning how to manage your energy is part of becoming stronger.',
        },
        {
          title:'Freedom From Ego',
          text:
          'A surprising number of players are more afraid of looking weak than they are interested in improving. This mindset slows progress tremendously. If your identity depends on always appearing strong, every loss becomes painful. But when you focus on learning instead of protecting your ego, improvement becomes much faster.',
        },
      ]},
      { type: 'h2', text: 'Hard Work vs Smart Work' },
      {
        type: 'p',
        text: 'There are generally two ways people approach improvement.',
      },
      {
        type: 'p',
        text: 'The first is brute force: endless games, endless studying, and exhausting schedules. While this can work, it is often inefficient and difficult to sustain long term.',
      },
      {
        type: 'p',
        text: 'The second approach is smarter and more structured. Instead of simply spending more time, you learn how to study effectively, how to stay disciplined, how to analyze mistakes properly, and how to maintain a healthy mindset.',
      },
      {
        type: 'p',
        text: 'In my experience, psychology is what connects all of these things together. Without discipline, good study plans fail. Without emotional control, strong reading disappears under pressure. Without self-awareness, players repeat the same mistakes for years.',
      },
      { type: 'h2', text: 'The Goal of Improvement' },
      {
        type: 'p',
        text: 'As a teacher, I believe Go should be more than chasing wins. Winning is important, but if your only goal is victory, frustration becomes inevitable. Improvement comes much faster when you focus on playing better rather than simply achieving better results.',
      },
      {
        type: 'p',
        text: 'One idea I often share with students is this:',
      },
      {
        type: 'quote',
        text: 'Don’t focus on who won. Focus on who played better.',
      },
      {
        type: 'p',
        text: 'It is possible to lose a high-quality game because of one mistake, just as it is possible to win a poor game because your opponent made an even bigger one. When you stop obsessing over the result itself, you begin to play with more clarity, confidence, and freedom.',
      },
      {
        type: 'p',
        text: 'Even if you lose a game, you might still have played better than your opponent overall. Winning or losing doesn’t matter.. What really matters is the quality of your decisions and how well you played. In the end, the true winner is the player who played the better game.',
      },
      {
        type: 'p',
        text: 'And ironically, that often leads to more victories as well.',
      },
      { type: 'h2', text: 'Final Thoughts' },
      {
        type: 'p',
        text: 'Psychology is not separate from Go. It is part of the game itself. The way you handle pressure, mistakes, fear, discipline, and confidence directly affects the moves you play on the board.',
      },
      {
        type: 'p',
        text: 'Improvement is not only about learning new patterns or reading deeper variations. It is also about understanding yourself better as a player. And in many cases, that mental shift is what allows real progress to happen.',
      },
    ],
  },
  {
    
    id: 2,
    slug: 'The One Thing You Need to Succeed: Attitude',
    title: 'The One Thing You Need to Succeed: Attitude',
    excerpt:
      'I believe attitude is one of the biggest factors behind improvement and long-term success.',
    date: 'Apr 25, 2025',
    readTime: '7 min read',
    category: 'Psychology',
    author: 'Kango9',
    image:
      'https://images.pexels.com/photos/37403742/pexels-photo-37403742.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    content: [
      {
        type: 'p',
        text: 'A few weeks ago, I wrote about the psychology behind playing Go. This time, I want to talk about something even more important, something that applies not only to Go, but to almost everything in life.',
      },
      { type: 'h2', text: 'Your attitude.'},
      {
        type: 'p',
        text: 'Honestly, I believe attitude is one of the biggest factors behind improvement and long-term success. Whether you’re learning Go, starting a new job, going to the gym, or picking up any new skill, you’ve probably noticed something interesting: some people improve incredibly fast, while others stay stuck for years.',
      },
      {
        type: 'p',
        text: 'Why is that?',
      },
      {
        type: 'p',
        text: 'In my experience, the answer is rarely talent alone. A huge part of it comes down to mindset.',
      },
      {
        type: 'p',
        text: 'One thing I’ve seen many times is people blaming everything except themselves when things go wrong. They blame bad luck, difficult opponents, lack of time, or circumstances outside their control. But the moment you stop taking responsibility for your mistakes, you also stop learning from them. And that slows improvement more than anything else.',
      },
      {
        type: 'p',
        text: 'Of course, having more free time, better study materials, or stronger opponents can help. But none of those things matter if your mindset is wrong. Without the right attitude, even the best resources become useless. If you look at top Go players, they all share something in common: a healthy attitude toward learning and improvement.',
      },
      {
        type: 'p',
        text: 'That’s why I always tell my students that improvement is not about how many books you own, how many games you play, or how much money you spend on lessons. Those things can help, but they are secondary. What matters most is how you approach the process.',
      },
      { type: 'h2', text: 'What Makes a Good Mindset?' },
      { type: 'list', items: [
        {
          title: 'Focus on the quality of your play, not only the result',
          text:
          'Winning doesn’t automatically mean you played well, and losing doesn’t automatically mean you played badly. Sometimes you win because your opponent made a bigger mistake. Sometimes you lose despite playing a strong game overall. What truly matters is the quality of your decisions and whether you are improving from game to game.',
        },
        {
          title:'Stay curious',
          text:
          'Good players are always willing to learn. They ask questions, explore new ideas, and stay open-minded even when they’re wrong. Ego kills improvement faster than mistakes ever will. And no matter your level, there is always something you can learn from someone else.',
        },
        {
          title:'Take responsibility',
          text:
          'If you lose, try to understand why instead of searching for excuses. Responsibility is powerful because it gives you control. Once you accept that your mistakes are yours, you also gain the ability to fix them. That’s where real progress begins.',
        },
        {
          title:'Don’t hide behind AI',
          text:
          'This is something I see more and more often. Saying “AI says this move is correct” means very little if you don’t actually understand the idea behind it. Memorizing moves without understanding creates the illusion of improvement, but not real strength. Understanding always matters more than copying.',
        },
        {
          title:'Appreciate progress',
          text:
          'Improvement is a long journey, and most progress happens slowly. Celebrate small victories. Notice the things you understand now that confused you a few months ago. Support other players when they improve too. A healthy mindset makes the entire process more enjoyable and sustainable.',
        },
      ]},
      { type: 'h2', text: 'Final Thoughts' },
      {
        type: 'p',
        text: 'At the end of the day, attitude shapes everything. Two people can study the same material, play the same number of games, and spend the same amount of time practicing, yet one improves dramatically faster simply because they approach learning differently.',
      },
      {
        type: 'p',
        text: 'With the right mindset, improvement becomes much easier. Not because the game becomes easier, but because you learn how to handle failure, pressure, mistakes, and growth in a healthier way. And honestly, that skill goes far beyond Go.',
      },
      {
        type: 'p',
        text: 'So what do you think? Do you believe attitude is one of the biggest factors behind improvement?',
      },
      
    ],
  },
  
];

export const heroImage = 'https://images.pexels.com/photos/31458768/pexels-photo-31458768.jpeg';
